import { getUserMentionOptions } from '#pplx/frontend/apps/ask/mention-typeahead/getUserMentionOptions.js';
import { normalizeUserMentionSearchQuery, userMentionQueryOptions, } from '#pplx/frontend/apps/ask/mention-typeahead/userMentionQueryOptions.js';
import { useUserMentionContext } from '#pplx/frontend/apps/ask/mention-typeahead/useUserMentionContext.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useDebouncedValue } from '#pplx/frontend/common/hooks/useDebouncedValue.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useMemo } from 'react';
const SEARCH_DEBOUNCE_MS = 300;
export function useAtMentionUsers({ reason, searchQuery, enabled = true, }) {
    const { featureEnabled, orgUuid, onSelect } = useUserMentionContext({ reason, enabled });
    const debouncedSearchQuery = useDebouncedValue(normalizeUserMentionSearchQuery({ searchQuery }), SEARCH_DEBOUNCE_MS);
    const { data, isLoading } = useQuery(userMentionQueryOptions({
        reason,
        searchQuery: debouncedSearchQuery,
        orgUuid,
        enabled: featureEnabled,
    }));
    const mentionUsersOptions = useMemo(() => {
        if (!featureEnabled) {
            return EMPTY_ARRAY;
        }
        return getUserMentionOptions({
            members: data?.member_list ?? EMPTY_ARRAY,
            onSelect,
        });
    }, [data, featureEnabled, onSelect]);
    return useMemo(() => ({
        isAtMentionUsersEnabled: featureEnabled,
        mentionUsersOptions,
        isLoading,
    }), [featureEnabled, isLoading, mentionUsersOptions]);
}
//# sourceMappingURL=useAtMentionUsers.js.map